import { Tooltip } from '@ads/components-react';
import { InformationCircle } from '@ads/icons';
import { cn } from '@linka/utils';

export function ChartGroupCard({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card'
      className={cn('border border-ctx-layout-border p-xxxs rounded-md flex flex-col gap-xxs w-full', className)}
      {...props}
    />
  );
}

export function ChartGroupCardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-header'
      className={cn('flex items-center justify-between text-ctx-content-title', className)}
      {...props}
    />
  );
}

export function ChartGroupCardTitle({
  className,
  children,
  tooltip,
  ...props
}: React.ComponentProps<'div'> & { tooltip?: string }) {
  return (
    <div data-slot='card-title' className='text-ctx-content-title ts-heading-sm flex items-center gap-nano' {...props}>
      {children}
      {tooltip && (
        <Tooltip title={tooltip} side='right'>
          <InformationCircle size={20} />
        </Tooltip>
      )}
    </div>
  );
}

export function ChartGroupCardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot='card-content' className={cn(className)} {...props} />;
}
